import PublicAPI from "../../../services/api";

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
};

export const authAPI = {

    login_client: async (data) => {
        return await PublicAPI.post('/auth/login', data)
    },

    register_client: async (data) => {
        return await PublicAPI.post('/auth/register', data)
    },

    get_client_info: async () => {
        const response = await PublicAPI.get('/auth/me', getHeaders());
        return response;
    },

    update_client_info: async (data) => {
        return await PublicAPI.put('/user/update', data, getHeaders())
    },

    // 🔐 solicitar reset de senha
    request_password_reset: async (data) => {
        return await PublicAPI.post('/auth/forgot-password', data)
    },

    // 🔐 redefinir senha com token
    reset_password: async (token, data) => {
        return await PublicAPI.post(`/auth/reset-password/${token}`, data)
    }

}